import {ModalService} from "../service/modal-without-ioc";
import {LoadingService} from "../service/loading-without-ioc";

export class MessageModalComponent {

    private $root:JQuery;
    private $modal:JQuery;
    public modalService: ModalService;
    public loadingService: LoadingService;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    /**
     * Sets up fancy box for this gallery. Sets up filter functionality.
     */
    private bindUI() {
        this.$root.on({ click: this.handleClick });
    }

    handleClick = (ev:MouseEvent) => {
        ev.preventDefault();
        let recipients:string[] = [];
        if (undefined !== this.$root.data('recipient')) {
            if ('all' === this.$root.data('recipient')) {
                let selector = this.$root.data('recipient_target');
                if (undefined !== selector) {
                    $(selector).find('[data-id]').each((index, elem) => {
                        recipients.push($(elem).data('id'));
                    })
                }
            } else {
                recipients.push(this.$root.data('recipient'));
            }
        } else {
            if (0 !== this.$root.closest('[data-id]').length) {
                recipients.push(this.$root.closest('[data-id]').data('id'));
            }
        }
        if (recipients.length !== 0) {
            let subject = this.$root.data('subject');
            this.loadingService.showLoading();
            $.ajax({
                url: '/members/messages/ajax-create',
                data: {
                    'recipients': recipients,
                    'subject': subject
                }
            }).then(
                (rawResponse) => {
                    let response = JSON.parse(rawResponse);
                    this.loadingService.hideLoading();
                    if (response.status === 'success') {
                        this.$modal = this.modalService.buildModal(
                            'Send message',
                            response.html,
                            [
                                {
                                    label: 'Close',
                                    class: 'btn btn-primary',
                                    events: { click: this.handleClose }
                                },
                                {
                                    label: 'Send',
                                    class: 'btn btn-danger',
                                    events: { click: this.handleSubmit }
                                }
                            ]
                        );
                        this.$modal.foundation('open');
                    } else {
                        alert(response.message);
                    }
                }
            )
        } else {
            alert('We could not find any recipients to send a message to. Please check and try again.');
        }
    }

    handleSubmit = () => {
        let $form = this.$modal.find('form');
        if ($form.length > 0) {
            let data = new FormData($form.get(0));
            this.$modal.foundation('close');
            this.loadingService.showLoading();
            $.ajax({
                url: '/members/messages/ajax-send',
                data: data,
                contentType: false,
                processData: false,
                type: 'POST'
            }).then(
                (rawResponse) => {
                    let response = JSON.parse(rawResponse);
                    this.loadingService.hideLoading();
                    if (response.status === 'success') {
                        alert('Your message was successfully sent.')
                        $form.find(':input').removeClass('disabled').removeAttr('disabled');
                        this.handleClose();
                    } else {
                        alert('Something went wrong when trying to send this message. Check your connection and try again.')
                        this.loadingService.hideLoading();
                        this.$modal.foundation('open');
                    }
                },
                () => {
                    alert('Something went wrong when trying to send this message. Check your connection and try again.')
                    this.loadingService.hideLoading();
                    this.$modal.foundation('open');
                }
            );
        }
    }

    handleClose = () => {
        this.$modal.foundation('close');
        this.$modal.remove();
        this.$modal = null;
    }

    public setModalService(modal:ModalService) {
        this.modalService = modal;
    }

    public setLoadingService(loading:LoadingService) {
        this.loadingService = loading;
    }
}